const logout = () => {
    localStorage.clear();
    window.location.hash = '';
    window.location.href = `${window.location.origin}/`;
};

export default logout;
